/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EstimatedCostDtoPage } from '../../models/estimated-cost-dto-page';

export interface ListEstimatedCosts$Params {
  budgetVersionIds?: Array<string>;
  projectId?: string | null;
  costTypeIds?: Array<string>;
  wpIds?: Array<string>;
  from?: string | null;
  to?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'from' | '-from' | 'to' | '-to' | 'total' | '-total' | 'project' | '-project' | 'budget' | '-budget' | 'budgetVersionId' | '-budgetVersionId' | 'budgetName' | '-budgetName' | 'costType' | '-costType' | 'costTypeName' | '-costTypeName' | 'workPackage' | '-workPackage' | 'workPackageName' | '-workPackageName' | 'comment' | '-comment' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt' | 'consumption' | '-consumption' | 'consumptionPerc' | '-consumptionPerc'>;
}

export function listEstimatedCosts(http: HttpClient, rootUrl: string, params?: ListEstimatedCosts$Params, context?: HttpContext): Observable<StrictHttpResponse<EstimatedCostDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listEstimatedCosts.PATH, 'get');
  if (params) {
    rb.query('budgetVersionIds', params.budgetVersionIds, {});
    rb.query('projectId', params.projectId, {});
    rb.query('costTypeIds', params.costTypeIds, {});
    rb.query('wpIds', params.wpIds, {});
    rb.query('from', params.from, {});
    rb.query('to', params.to, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EstimatedCostDtoPage>;
    })
  );
}

listEstimatedCosts.PATH = '/v0/estimatedCost';
